import { Skeleton } from "@/shared/ui/skeleton"

export function PostCardSkeleton() {
	return (
		<div className="overflow-hidden rounded-3xl bg-card ring-1 ring-white/10">
			<Skeleton className="aspect-video w-full rounded-none" />
			<div className="space-y-2 p-4 sm:p-5">
				<Skeleton className="h-3 w-24" />
				<Skeleton className="h-6 w-4/5" />
				<Skeleton className="h-4 w-full" />
				<div className="flex gap-1.5 pt-2">
					<Skeleton className="h-6 w-20 rounded-full" />
					<Skeleton className="h-6 w-24 rounded-full" />
				</div>
				<Skeleton className="mt-2 h-9 w-32 rounded-full" />
			</div>
		</div>
	)
}
